import { Component } from 'react';
import type { ReactNode } from 'react';
import { ApiError } from '@ooh/contracts';

interface ErrorBoundaryProps {
  onReset: () => void;
  renderError: (retry: () => void, error: unknown) => ReactNode;
  children: ReactNode;
}

interface ErrorBoundaryState {
  failed: boolean;
  error: unknown;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { failed: false, error: null };

  static getDerivedStateFromError(error: unknown): ErrorBoundaryState {
    return { failed: true, error };
  }

  componentDidCatch(error: Error): void {
    // An HTTP failure is an expected state the boundary renders; e2e treats console errors as bugs.
    if (error instanceof ApiError) return;
    console.error('[screens] boundary caught', error);
  }

  private retry = (): void => {
    this.props.onReset();
    this.setState({ failed: false, error: null });
  };

  render(): ReactNode {
    return this.state.failed
      ? this.props.renderError(this.retry, this.state.error)
      : this.props.children;
  }
}
